<template>
  <div class="common_contentBox">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="名称管理" name="nameManagement"></el-tab-pane>
      <el-tab-pane label="物料管理" name="materialManagement"></el-tab-pane>
      <component :is="activeName"></component>
    </el-tabs>
  </div>
</template>

<script>
import nameManagement from './component/hqActivityManagement/nameManagement';
import materialManagement from './component/hqActivityManagement/materialManagement';
export default {
  data () {
    return {
      activeName: 'nameManagement',
    };
  },
  components: {
    nameManagement,
    materialManagement
  },
  methods: {

  },
  mounted () {
  }
};
</script>

<style scoped>
.common_button {
  margin-bottom: 16px;
}
</style>
